import { useAppSelector, useUser } from "../app/hooks";
import ToolsOverview from "./common/tools/ToolsOverview";
import DisplayUser from "./common/users/DisplayUser";

function Profile() {
  const userId = useAppSelector((state) => state.auth.userId);
  const { user } = useUser(userId);

  if (user === null) return <></>;

  return (
    <>
      <DisplayUser user={user} />
      <ToolsOverview user={user} />
    </>
  );
}

export default Profile;
